import { createSlice } from "@reduxjs/toolkit";
import { sortBranchesPutTestLast } from "@helpers/sortBranchesPutTestLast";

const initialState = {
    subscribe: {
        brandId: null,
        rule: {},
        plan: [],
        status: null,
        activationDate: null,
        cardInfo: {},
        branches: [],
    },
};

const subscribeSlice = createSlice({
    name: "subscribe",
    initialState: initialState,
    reducers: {
        // 登入 方案
        setSubscribePlan(state, action) {
            const { brandId, rule, plan, status, activationDate } = action.payload;
            state.subscribe.brandId = brandId;
            state.subscribe.rule = rule;
            state.subscribe.plan = plan;
            state.subscribe.status = status;
            state.subscribe.activationDate = activationDate;
        },
        // 登入 訂閱
        setSubscribeBranches(state, action) {
            const { branches } = action.payload;
            state.subscribe.branches = sortBranchesPutTestLast(branches || []);
        },
        // 取消訂閱
        cancelSubscribeBranch(state, action) {
            const { branch_id, updated_at } = action.payload;
            let branches = state.subscribe.branches;
            let branch = branches.find(item => item.branch_id === branch_id); // 找到 id 為 3 的物件
            if (branch) {
                branch.next_deduction = null;
                branch.expire_time = branch.next_deduction;
                branch.updated_at = updated_at;
            }
        },
        // 設定信用片
        setCardInfo(state, action) {
            const { cardInfo } = action.payload;
            state.subscribe.cardInfo = cardInfo;
        },
        // 登出
        setLogoutForSubscribe(state) {
            state.subscribe = {
                ...initialState.subscribe,
            };
        },
        // 重新訂閱
        updateSubscribeBranch(state, action) {
            const { branchId, nextDeduction, expireTime } = action.payload;
            const branchState = state.subscribe.branches.find((branch) => branch.id === branchId);
            if (branchState) {
                branchState.branch_id = branchId;
                branchState.next_deduction = nextDeduction;
                branchState.expire_time = expireTime;
            }
        },
        // 更改方案
        updateSubscribePlan(state, action) {
            const { brandId, rule, status, activationDate, plan } = action.payload;
            state.subscribe.brandId = brandId;
            state.subscribe.rule = rule;
            state.subscribe.status = status;
            state.subscribe.activationDate = activationDate;
            state.subscribe.plan = plan;
        },

        // 刪除分店
        setDeleteBranch(state, action) {
            const branchId = action.payload;
            state.subscribe.branches = state.subscribe.branches.filter((i) => i.id !== branchId);
        }
    },
});

export const {
    setSubscribePlan,
    setSubscribeBranches,
    setCardInfo,
    setLogoutForSubscribe,
    cancelSubscribeBranch,
    updateSubscribeBranch,
    updateSubscribePlan,
    setDeleteBranch
} = subscribeSlice.actions;

export default subscribeSlice.reducer;